import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getWithdrawRequestDetail } from '../withdrawRequestsEndpoints'
import { withdrawRequestKeys } from '../withdrawRequestsQueryKeys'

export function useWithdrawRequestDetailQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => withdrawRequestKeys.detail(toValue(id)),
    queryFn: () => getWithdrawRequestDetail(toValue(id)),
    enabled: () => !!toValue(id),
  })
}
